import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'
import {Form} from 'simple-react-form'
import map from 'lodash/map'
import FormFields from 'App/components/FormFields'
import Save from '../../Save'

@withRouter
export default class SellNoteForm extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    getPreparation: PropTypes.object
  }

  state = {}

  componentDidMount() {
    let object = {}
    const values = this.props.getPreparation.sellNoteFieldsValues || []
    map(this.props.getPreparation.sellNoteFieldsNames, function(fvalue, key) {
      object[key] = values[key]
    })
    this.setState(object)
  }

  render() {
    const {sellNoteFields} = this.props.getPreparation
    return (
      <div className={styles.container}>
        <div className="content">
          <div className={styles.subTitle}>
            La nota de venta contiene los siguientes datos globales:
          </div>
          <Form state={this.state} onChange={changes => this.setState(changes)}>
            <FormFields fields={sellNoteFields} className={'col-xs-12 col-sm-4'} hasTitle={false} />
          </Form>
          <div className={styles.save}>
            <Save
              value={this.state}
              getPreparation={this.props.getPreparation}
              fieldType={'sellNote'}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/SSSellNote/SellNoteForm/index.js